<template>
<div>
  <button @click="goBack" class="back-button-container"
          :class="{'back-button-container_isef': this.$isIsef}">
    <i class="fal fa-chevron-left"></i>
    <h4>{{$t('banners.buttons.back')}}</h4>
  </button>
</div>
</template>

<script>
export default {
  props: ['backButton'],
  methods: {
    goBack: function () {
      if (window.history.length < 2) {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~styles/utils.scss';
  .back-button-container {
    position: absolute;
    z-index: 2;
    display: flex;
    width: 4rem;
    background-color: rgba(255, 255, 255, 0.5);
    border: none;
    box-shadow: 0px 0px 0px transparent;
    height: 2rem;
    padding: 1rem;
    justify-content: center;
    align-items: center;
    top: 1%;
    left: 6%;
    border-radius: 18%;

    &_isef {
      z-index: 10 !important;
    }

    @media(max-width: 1023px) {
      top: 8%;
      left: 6%;
    }
    h4 {
      padding-left: 0.35rem;
      font-weight: bold;
      font-size: 0.8rem;
    }
    i {
      font-weight: bold;
      font-size: 0.95rem;
    }
    &:hover {
      background-color: rgba(255, 255, 255, 0.6);
      transition: all 0.5s;
      cursor: pointer;
      scale: 1.05;
    }
  }
</style>
